var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(_vm.previewItemFromType(_vm.listPreviews, _vm.codename),{tag:"component",attrs:{"audiourl":_vm.audio,"listaudio":_vm.audios,"thumburl":_vm.thumb,"listimages":_vm.thumbs}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb33557e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiPreviewItem.vue
// module id = 416
// module chunks = 1